import * as React from 'react';

import { FactureAchat, ReminderPublisher } from '@europrocurement/l2d-domain';
import { associateInvoiceToReminderPublisherIcon } from '@europrocurement/l2d-icons';
import { DataSource, getDataThunkType } from '@europrocurement/l2d-redux-utils';
import { FlexyButton } from './FlexyButton';
import { useAssociateInvoiceModal } from './AssociateInvoice/hooks/useAssociateInvoiceModal';

/**
 * Button component to trigger the associate invoice modal.
 *
 * @param {Object} props - Component props.
 * @param {ReminderPublisher} [props.reminderPublisher] - Reminder publisher data.
 * @param {DataSource<FactureAchat>} [props.reminderPublisher] - Reminder publisher data.
 * @param {getDataThunkType<FactureAchat>} [props.fetchData] - Function to fetch updated invoice data.
 * @returns {JSX.Element} - Rendered button component.
 */
const AssociateInvoiceButton: React.FunctionComponent<{
    reminderPublisher?: ReminderPublisher;
    dataSource?: DataSource<FactureAchat>;
    fetchData?: getDataThunkType<FactureAchat>;
}> = function ({ reminderPublisher, dataSource, fetchData }) {
    const { openAssociateModal } = useAssociateInvoiceModal(
        reminderPublisher,
        dataSource,
        fetchData,
    );

    return (
        <FlexyButton
            label="Associer une facture"
            onClick={openAssociateModal}
            icon={associateInvoiceToReminderPublisherIcon}
            disabled={!reminderPublisher || reminderPublisher.status === 'sent'}
        />
    );
};

export default AssociateInvoiceButton;
